export enum FieldsName {
  url = 'url',
  label = 'label',
  targetSmartLinkId = 'targetSmartLinkId',
}

export type FieldsType = {
  [FieldsName.url]: string;
  [FieldsName.label]: string;
  [FieldsName.targetSmartLinkId]?: number;
};
